
import React from 'react'
import FontAwesome from 'react-fontawesome'
import PropTypes from 'prop-types'
import EmptyIllustration from './EmptyIllustration'
import './styles.css'
import NotificationItem from './NotificationItem'
import { Link } from "react-router"
import { connect } from 'react-redux'
import { blockingFetchService } from '../../lib/blockingFetch'
import apiServerApi from '../../redux/sagas/apiServerApi'
import {
  setNotifications,
  appendNotifications,
  updateNotification,
  removeNotification,
  setPagination,
  selectors as notificationsSelectors,
  markAllAsRead,
  deleteAllNotifications,
  fetchUnreadCount,
} from '../../redux/notifications'
import { Button } from 'react-bootstrap'
import AlertModal from '../fragments/AlertModal'
import { DEFAULT_NAV_SIZE_50, FIVE_MINUTES_MS } from '../../lib/utils'
import NavbarButton from '../App/NavbarButton'

export const NotificationType = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
}

class NotificationPopover extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false,
      filter: 'all',
      menuOpen: false,
      currentPage: 0,
      loading: false,

      deleteAllClicked: false,
      readAllClicked: false,
    }

    this.popoverRef = null
    this.buttonRef = null
    this.menuRef = null
    this.unreadInterval = null
  }

  loadData = async (page = 0, append = false) => {

    this.setState({ loading: true })

    blockingFetchService(
      accessToken => apiServerApi.getNotifications(accessToken, page, DEFAULT_NAV_SIZE_50),
      (payload = {}) => {

        const actionPayload = {
          items: payload.content || [],
          totalElements: payload.totalElements || 0,
          pageSize: payload.pageSize || DEFAULT_NAV_SIZE_50,
          currentPage: payload.currentPage != null ? payload.currentPage : page,
          hasNext: Boolean(payload.hasNext),
        }

        if (append) {
          this.props.appendNotifications(actionPayload)
        }
        else {
          this.props.setNotifications(actionPayload)
        }

        this.props.setPagination({ totalElements: actionPayload.totalElements, hasNext: actionPayload.hasNext, currentPage: actionPayload.currentPage })
      },
      error => {
        console.error('Unable to load notifications', error)
      },
      _ => this.setState({ loading: false })
    )
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick)
    this.loadData(0, false)
    this.props.fetchUnreadCount(true)
    this.scheduleUnreadCountFetch()
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick)
    if (this.unreadInterval) clearInterval(this.unreadInterval)
  }

  scheduleUnreadCountFetch = () => {
    try {
      this.unreadInterval = setInterval(() => this.props.fetchUnreadCount(), FIVE_MINUTES_MS)
    }
    catch (e) {
      console.error(e)
      this.unreadInterval = null
    }
  }

  setPopoverRef = node => {
    this.popoverRef = node
  }

  setButtonRef = node => {
    this.buttonRef = node
  }

  setMenuRef = node => {
    this.menuRef = node
  }

  toggleOpen = () => {
    this.setState(prev => ({ open: !prev.open }), () => {
      if (this.state.open) {
        this.loadData(0, false)
        this.props.fetchUnreadCount(true)
      }
    })
  }

  handleDocumentClick = event => {

    const { open, menuOpen } = this.state,
    target = event.target

    if (open && this.popoverRef && !this.popoverRef.contains(target) && this.buttonRef && !this.buttonRef.contains(target)) {
      this.setState({ open: false, menuOpen: false })
    }

    if (menuOpen && this.menuRef && !this.menuRef.contains(target)) {
      this.setState({ menuOpen: false })
    }
  }

  handleMarkRead = id => {
    blockingFetchService(
      accessToken => apiServerApi.markAllNotificationsRead(accessToken, [id]),
      () => {
        this.props.updateNotification(id, { read: true })
        this.props.fetchUnreadCount(true)
      },
      error => console.error('Unable to mark as read', error),
      () => {}
    )
  }

  handleDelete = id => {
    blockingFetchService(
      accessToken => apiServerApi.deleteAllNotifications(accessToken, [id]),
      () => {
        this.props.removeNotification(id)
        this.props.fetchUnreadCount(true)
      },
      error => console.error('Unable to delete notification', error),
      () => {}
    )
  }

  handleMarkAllRead = () => {
    blockingFetchService(
      accessToken => apiServerApi.markAllNotificationsRead(accessToken),
      () => {
        this.props.markAllAsRead()
        this.setState({ menuOpen: false })
      },
      error => console.error('Unable to mark all read', error),
      () => {}
    )
  }

  handleDeleteAll = () => {
    blockingFetchService(
      accessToken => apiServerApi.deleteAllNotifications(accessToken),
      () => {
        this.props.deleteAllNotifications()
        this.setState({ menuOpen: false })
      },
      error => console.error('Unable to delete notifications', error),
      () => {}
    )
  }

  render() {

    const { open, filter, menuOpen, loading, readAllClicked, deleteAllClicked } = this.state,
    items = this.props.notifications || [],
    meta = this.props.meta || {},

    unreadCount = this.props.unreadCount || 0,
    filtered = filter === 'unread' ? items.filter(n => !n.read) : items

    return (
      <div className='relative'>
        <NavbarButton
          innerRef={ this.setButtonRef }
          onClick={ this.toggleOpen }
          count={ unreadCount }
          ariaExpanded={ open }
          iconName="bell-o"
          iconBgColor="bg-blue-600"
          title="Notifications"
        />

        { open && (
          <div ref={ this.setPopoverRef } className='notification-popover-cont'>
            <div className="notification-popover-header">
              <div className="notification-popover-header-top">
                <div>
                  <h2 className="notification-popover-title">Notifications</h2>
                  <p className="notification-popover-meta">
                    { unreadCount > 0 ? `${ unreadCount } unread notification${ unreadCount > 1 ? 's' : '' }` : 'No unread notifications' }
                  </p>
                </div>

                <div className='relative' ref={ this.setMenuRef }>
                  <button
                    onClick={() => this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }))}
                    className="notification-more-button"
                    aria-label="More options"
                  >
                    <FontAwesome name="ellipsis-v" className='text-sm' />
                  </button>
                  { menuOpen && (
                    <div className="notification-more-menu">

                      <button onClick={() => this.setState({ readAllClicked: true })} disabled={ !unreadCount }
                        className={ `notification-menu-button` }>
                        <FontAwesome name="check-circle" className="notification-menu-icon notification-menu-icon--primary" />
                        Mark all as read
                      </button>

                      <div className="notification-menu-divider" />

                      <button onClick={() => this.setState({ deleteAllClicked: true })} disabled={ !items.length }
                        className={ `notification-menu-button notification-menu-button--danger` }>
                        <FontAwesome name="trash" className="notification-menu-icon" />
                        Delete all notifications
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className='flex-row gap-1'>

                <div className='flex gap-1 bg-gray-100 p-5 rounded-10'>
                  <button
                    onClick={() => this.setState({ filter: 'all' })}
                    className={ `notification-filter-button ${filter === 'all' ? 'notification-filter-button--active' : ''}` }
                  >
                    All
                  </button>
                  <button
                    onClick={() => this.setState({ filter: 'unread' })}
                    className={ `notification-filter-button ${filter === 'unread' ? 'notification-filter-button--active' : ''}` }
                  >
                    <FontAwesome name="filter" className='text-sm' />
                    Unread
                    { unreadCount > 0 && <span className="notification-filter-badge">{ unreadCount }</span> }
                  </button>
                </div>

                { loading && <div className="spinner-sm" /> }
              </div>
            </div>

            <div className="notification-popover-body">
              { !filtered.length ? (
                <div className="notification-popover-empty-state">
                  <EmptyIllustration />
                  <h3 className="notification-empty-title">{ filter === 'unread' ? 'No unread notifications' : "No notifications" }</h3>
                  <p className="notification-empty-text">
                    { filter === 'unread'
                      ? 'Great job! All your notifications have been read.'
                      : "Take a break, we'll let you know when something new arrives."
                    }
                  </p>
                  { filter === 'unread' && (
                    <button onClick={() => this.setState({ filter: 'all' })} className="notification-empty-action">
                      View all notifications
                    </button>
                  )}
                </div>
              ) : (
                <div>
                  { filtered.map(n => (
                    <NotificationItem
                      key={ n.id }
                      notification={ n }
                      onMarkRead={ this.handleMarkRead }
                      onDelete={ this.handleDelete }
                    />
                  ))}
                  { meta.hasNext && (
                    <div className='align-right p-10'>
                      <Button onClick={() => this.loadData((meta.currentPage || 0) + 1, true)}
                        bsStyle="default" disabled={ loading }>
                        { loading ? 'Loading...' : 'Load more' }
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className='block shrink-0 p-10 border-t-1 border-gray-200 align-center'>
              <Link to="/notifications" className="font-600" onClick={() => this.setState({ open: false })}>
                Notification Center →
              </Link>
            </div>
          </div>
        )}

        <AlertModal
          show={ readAllClicked }
          title="Confirm update"
          body={ <h3>This action will mark all notifications as read</h3> }
          bsStyle="danger"
          close={() => this.setState({ readAllClicked: false })}
          confirm={() => {
            this.setState({ readAllClicked: false })
            this.handleMarkAllRead()
          }}
          proceedText="Proceed"
        />

        <AlertModal
          show={ deleteAllClicked }
          title="Confirm deletion"
          body={ <h3>This action will delete all notifications</h3> }
          bsStyle="danger"
          close={() => this.setState({ deleteAllClicked: false })}
          confirm={() => {
            this.setState({ deleteAllClicked: false })
            this.handleDeleteAll()
          }}
          proceedText="Delete all"
        />
      </div>
    )
  }
}

NotificationPopover.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.string,
      read: PropTypes.bool.isRequired,
      type: PropTypes.oneOf(['SUCCESS', 'ERROR', 'WARNING', 'INFO']).isRequired,
      createdOn: PropTypes.string.isRequired,
    })
  ),
}

const mapState = state => ({
  notifications: notificationsSelectors.all(state),
  meta: notificationsSelectors.meta(state),
  unreadCount: notificationsSelectors.unreadCount(state),
})

const mapDispatch = {
  setNotifications,
  appendNotifications,
  updateNotification,
  removeNotification,
  setPagination,
  fetchUnreadCount,
  markAllAsRead,
  deleteAllNotifications,
}

export default connect(mapState, mapDispatch)(NotificationPopover)



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationPopover.js